<template>
  <form v-loading="loading && !model" @submit.prevent="submit()">
    <!-- Header -->
    <div v-if="!embeded" class="tournament-light-blue pa-3">
      <!-- Top -->
      <div class="row">
        <div class="row align-center flex">
          <v-btn class="ma-0" icon @click="$emit('close')">
            <v-icon color="tournament-white">
arrow_back
</v-icon>
          </v-btn>
        </div>
        <v-btn
          v-if="model && isEditable"
          :loading="loading"
          type="submit"
          class="ma-0 rounded"
          color="tournament-white tournament-green--text"
        >
          Salvar
        </v-btn>
      </div>

      <div v-if="model" class="row flex px-2 mt-3">
        <v-text-field
          v-model="model.name"
          v-validate="'required|min:2'"
          class="big-title"
          color="tournament-white"
          :class="
            !isEditable
              ? 'tournament-white--text translucid'
              : 'tournament-white--text'
          "
          :label="`Nome do ${titleLabel}`"
          type="text"
          data-vv-name="user.name"
          :data-vv-as="`nome do ${titleLabel}`"
          :error-messages="errors.collect('user.name')"
          :disabled="!isEditable"
        />
      </div>
    </div>

    <!-- Form -->
    <div
      v-loading="!model.general && !model.formation"
      class="tournament-white px-4 pt-3 pb-5"
      style="min-height: 300px"
      element-loading-text="Carregando dados"
    >
      <div>
        <div v-if="community !== 'fll-open-brazil'">
          <!-- CPF -->
          <div class="row flex px-2 mt-3" v-if="model">
            <v-text-field
              v-model="model.cpf"
              color="tournament-black"
              :class="
                !isEditable || !isNew
                  ? 'tournament-black--text translucid'
                  : 'tournament-black--text'
              "
              label="CPF"
              prepend-icon="account_circle"
              v-mask="'###.###.###-##'"
              v-validate="'required|min:13'"
              data-vv-name="user.cpf"
              data-vv-as="CPF"
              :error-messages="errors.collect('user.cpf')"
              :disabled="!isEditable || !isNew"
              class="mt-4 pl-2 tournament-black--text big-title"
            />
          </div>
        </div>
        <div v-else>
          <!-- Passport -->
          <div class="row flex px-2 mt-3" v-if="model">
            <v-text-field
              v-model="model.alias"
              color="tournament-black"
              :class="
                !isEditable || !isNew
                  ? 'tournament-black--text translucid'
                  : 'tournament-black--text'
              "
              label="Passport Number"
              prepend-icon="account_circle"
              v-mask="'XXXXXXXXXXXXXXXXXXXX'"
              v-validate="'required|min:8'"
              data-vv-name="user.cpf"
              data-vv-as="CPF"
              :error-messages="errors.collect('user.cpf')"
              :disabled="!isEditable || !isNew"
              class="mt-4 pl-2 tournament-black--text big-title"
            />
          </div>
        </div>

        <!-- Email -->
        <v-text-field
          v-model="model.email"
          v-validate="'required|email'"
          color="tournament-black"
          :class="
            !isEditable
              ? 'tournament-black--text translucid'
              : 'tournament-black--text'
          "
          class="ml-4 pl-2"
          label="Email"
          data-vv-name="user.email"
          data-vv-as="email"
          :error-messages="errors.collect('user.email')"
          :disabled="!isEditable"
        />

        <!-- Birth -->
        <v-text-field
          v-mask="'##/##/####'"
          v-validate="
            community === 'fll-open-brazil'
              ? 'required|date_format:MM/dd/yyyy'
              : 'required|date_format:dd/MM/yyyy'
          "
          :value="formatedBirth"
          color="tournament-black"
          class="ml-4 pl-2"
          :class="
            !isEditable || !isNew
              ? 'tournament-black--text translucid'
              : 'tournament-black--text'
          "
          label="Data de Nascimento"
          data-vv-name="user.birth"
          data-vv-as="data de nascimento"
          :error-messages="errors.collect('user.birth')"
          :disabled="!isEditable || !isNew"
          @input="model.birth = $event"
          @blur="validateDate(model, 'birth')"
        />

        <!-- Phone and cellphone (only for coaches) -->
        <div v-if="model.general && isCoach" class="row">
          <!-- Phone -->
          <v-text-field
            v-model="model.general.phone"
            v-mask="
              community === 'fll-open-brazil'
                ? '+####################'
                : ['(##) ####-####', '(##) #####-####']
            "
            v-validate="'required'"
            color="tournament-black"
            class="ml-4 pl-2"
            :class="
              !isEditable
                ? 'tournament-black--text translucid'
                : 'tournament-black--text'
            "
            label="Telefone"
            data-vv-name="user.phone"
            data-vv-as="telefone"
            :error-messages="errors.collect('user.phone')"
            :disabled="!isEditable"
            style="width: 50%"
          />

          <!-- Cellphone -->
          <v-text-field
            v-model="model.general.cellphone"
            v-mask="
              community === 'fll-open-brazil'
                ? '+####################'
                : ['(##) ####-####', '(##) #####-####']
            "
            v-validate="'required'"
            color="tournament-black"
            :class="
              !isEditable
                ? 'tournament-black--text translucid'
                : 'tournament-black--text'
            "
            class="ml-4 pl-2"
            label="Celular"
            data-vv-name="user.cellphone"
            data-vv-as="celular"
            :error-messages="errors.collect('user.cellphone')"
            :disabled="!isEditable"
            style="width: 50%"
          />
        </div>

        <!-- Gender -->
        <v-select
          v-if="model.general"
          v-model="model.general.gender"
          v-validate="'required'"
          color="tournament-black"
          :class="
            !isEditable
              ? 'tournament-black--text translucid'
              : 'tournament-black--text'
          "
          class="ml-4 pl-2"
          :items="possibleGender"
          label="Gênero"
          item-text="label"
          item-value="_id"
          data-vv-name="user.general.gender"
          data-vv-as="gênero"
          :error-messages="errors.collect('user.general.gender')"
          :disabled="!isEditable"
        />

        <!-- Formation -->
        <div v-if="model.formation" class="row">
          <v-select
            v-model="model.formation.formation"
            color="tournament-black"
            :class="
              !isEditable
                ? 'tournament-black--text translucid'
                : 'tournament-black--text'
            "
            class="ml-4 pl-2"
            :items="possibleFormation"
            label="Escolaridade"
            item-text="label"
            item-value="_id"
            :disabled="!isEditable"
          />
        </div>

        <!-- Series / Formation -->
        <div v-if="model.formation" class="row">
          <v-text-field
            v-model="model.formation.school"
            v-if="community === 'fll-open-brazil' ? !isCoach : true"
            v-validate="
              community === 'fll-open-brazil' ? '' : !isCoach ? 'required' : ''
            "
            color="tournament-black"
            :class="
              !isEditable
                ? 'tournament-black--text translucid'
                : 'tournament-black--text'
            "
            class="ml-4 pl-2"
            label="Instituição de Ensino"
            data-vv-name="user.formation.school"
            data-vv-as="instituição"
            :error-messages="errors.collect('user.formation.school')"
            style="width: 50%"
            :disabled="!isEditable"
          />

          <v-text-field
            v-if="!isCoach"
            v-model="model.formation.series"
            v-validate="
              community === 'fll-open-brazil' ? '' : !isCoach ? 'required' : ''
            "
            color="tournament-black"
            :class="
              !isEditable
                ? 'tournament-black--text translucid'
                : 'tournament-black--text'
            "
            class="ml-4 pl-2"
            label="Série/Ano"
            data-vv-name="user.formation.series"
            data-vv-as="série/ano"
            :error-messages="errors.collect('user.formation.series')"
            style="width: 50%"
            :disabled="!isEditable"
          />
        </div>

        <AddressForm
          v-model="model.address"
          class="ml-4 pl-2"
          :editing="isEditable"
        />
      </div>

      <article class="call-out mt-2 mb-2">
        <v-icon>info</v-icon>
        Se o integrante for maior de 18 anos, os campos abaixo devem ser preechidos com as mesmas informações
        usadas anteriormente.
      </article>

      <!-- Responsible area -->
      <div
        v-if="community !== 'fll-open-brazil' && model.responsible && !isCoach"
        class="mt-5"
      >
        <!-- Responsible Name -->
        <v-text-field
          v-model="model.responsible.name"
          v-validate="'required'"
          color="tournament-black"
          :class="
            !isEditable
              ? 'tournament-black--text translucid'
              : 'tournament-black--text'
          "
          label="Nome do responsável"
          prepend-icon="security"
          data-vv-name="user.responsible.name"
          data-vv-as="nome do responsável"
          :error-messages="errors.collect('user.responsible.name')"
          :disabled="!isEditable"
        />

        <!-- Responsible CPF -->
        <v-text-field
          v-model="model.responsible.cpf"
          v-mask="['###.###.###-##']"
          v-validate="'required|min:13'"
          color="tournament-black"
          :class="
            !isEditable
              ? 'tournament-black--text translucid'
              : 'tournament-black--text'
          "
          class="ml-4 pl-2"
          label="CPF do responsável"
          data-vv-name="user.responsible.cpf"
          data-vv-as="CPF do responsável"
          :error-messages="errors.collect('user.responsible.cpf')"
          :disabled="!isEditable"
        />

        <!-- Kinship and phone -->
        <div class="row">
          <!-- Kinship -->
          <v-text-field
            v-model="model.responsible.kinship"
            v-validate="'required'"
            color="tournament-black"
            :class="
              !isEditable
                ? 'tournament-black--text translucid'
                : 'tournament-black--text'
            "
            class="ml-4 pl-2"
            label="Grau de parentesco"
            data-vv-name="user.responsible.kinship"
            data-vv-as="grau de parentesco"
            :error-messages="errors.collect('user.responsible.kinship')"
            style="width: 50%"
            :disabled="!isEditable"
          />

          <!-- Phone -->
          <v-text-field
            v-model="model.responsible.phone"
            v-mask="['(##) ####-####', '(##) #####-####']"
            v-validate="'required'"
            color="tournament-black"
            :class="
              !isEditable
                ? 'tournament-black--text translucid'
                : 'tournament-black--text'
            "
            class="ml-4 pl-2"
            label="Telefone do responsável"
            data-vv-name="user.responsible.phone"
            data-vv-as="telefone do responsável"
            :error-messages="errors.collect('user.responsible.phone')"
            style="width: 50%"
            :disabled="!isEditable"
          />
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import i18n from "@/services/i18n";

import AddressForm from "@/components/AddressForm";
import User from "@/services/User";
import Team from "@/services/Team";

import ParseHTTPError from "@/helpers/ParseHTTPError";

export default {
  name: "UserEditor",

  components: {
    AddressForm,
  },

  props: {
    cache: {
      type: Object,
      default: () => {},
    },
    modelId: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "member",
    },
    teamId: {
      type: String,
      required: true,
    },
    enrollmentStatus: {
      type: String,
      default: "",
    },
    embeded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,

      model: {
        cpf: null,
        alias: null,
        community: "fll-brasil",
      },

      community: "fll-brasil",

      possibleFormation: [
        {
          label: "Ensino fundamental incompleto",
          _id: "fundamental-incomplete",
        },
        { label: "Ensino fundamental completo", _id: "fundamental-complete" },
        { label: "Ensino médio incompleto", _id: "medio-incomplete" },
        { label: "Ensino médio completo", _id: "medio-complete" },
        { label: "Cursando ensino médio", _id: "medio-graduating" },
        { label: "Ensino superior completo", _id: "superior-complete" },
        { label: "Mestrado completo", _id: "mestrado-complete" },
        { label: "Doutorado completo", _id: "doutorado-complete" },
        { label: "Pós-Doutorado completo", _id: "pos-doutorado-complete" },
        { label: "Nenhum", _id: "" },
      ],

      possibleGender: [
        { label: "Masculino", _id: "male" },
        { label: "Feminino", _id: "female" },
        { label: "Outro", _id: "other" },
      ],
    };
  },

  computed: {
    defaults() {
      return {
        name: null,
        birth: null,
        cpf: null,
        alias: null,
        general: {
          gender: null,
        },
        address: {},
        formation: {
          formation: null,
          school: null,
          series: null,
        },
        responsible: {
          name: null,
          kinship: null,
          cpf: null,
          alias: null,
          phone: null,
        },
      };
    },

    isNew() {
      return !this.modelId;
    },

    titleLabel() {
      return this.type == "coach" ? "técnico" : "integrante";
    },

    possibleYearsFoundation() {
      // Returns all years since 2004 (year of foundation FLL in Brazil)
      const years = [];
      const currentYear = new Date().getFullYear() || 2018;
      for (let year = 2004; year <= currentYear; year++) {
        years.push(year);
      }
      return years.reverse();
    },

    isCoach() {
      return this.type == "coach";
    },

    isEditable() {
      return this.enrollmentStatus == "waiting";
    },

    formatedBirth() {
      const val = this.model.birth;
      if (val && val.match(/^\d\d\d\d-\d\d-\d\dT?/)) {
        const newVal = moment(val).utc();
        if (newVal.isValid()) {
          return this.community === "fll-open-brazil"
            ? newVal.format("MM/DD/YYYY")
            : newVal.format("DD/MM/YYYY");
        }
      }
      return val;
    },
  },

  created() {
    // Set current model to show model faster (Cache version)
    if (this.cache && this.modelId == this.cache._id) {
      this.model = this.cache;
    }

    // Set Community
    this.community = window.LayersPortal.communityId;
    this.model.community = this.community;

    // Fetch model events and data
    if (this.modelId) {
      this.fetch();
    } else {
      // Creation mode
      this.model = this.defaults;
    }

    // if community is fll-open-brazil set language to en
    if (this.community === "fll-open-brazil") {
      i18n.locale = "en";
    }
  },

  methods: {
    fetch() {
      this.loading = true;

      User.get(this.modelId).then(
        (model) => {
          this.loading = false;
          this.model = _.defaultsDeep(model.data, this.defaults);
        },
        () => {
          this.loading = false;
          this.$notify.error({
            title: "Erro",
            message: "Tente novamente",
          });
          this.$emit("close");
        },
      );
    },

    submit() {
      this.$validator.validateAll().then((result) => {
        // If throw errors in form, return
        if (!result) {
          this.$notify.error({
            title: "Encontramos alguns erros",
            message: this.$createElement("Error", {
              props: {
                error: this.errors,
              },
            }),
          });
          return;
        }
        this.save();
      });
    },

    validateDate(obj, key) {
      const val = obj[key];
      if (val && val.match(/^\d\d\d\d-\d\d-\d\d$/)) {
        // If its already okay, keep it as it is
      } else if (val && val.match(/^\d\d\/\d\d\/\d\d\d\d$/)) {
        // Try parsing it to the new format
        const newVal =
          this.community === "fll-open-brazil"
            ? moment(val, "MM/DD/YYYY")
            : moment(val, "DD/MM/YYYY");
        if (newVal.isValid()) {
          obj[key] = newVal.format("YYYY-MM-DD");
        } else {
          obj[key] = val;
        }
      } else {
        obj[key] = val;
      }
    },

    save() {
      this.loading = true;

      // Depending if its creating or updating, select method to use
      const method = this.isNew ? Team.createUser : User.update;
      this.model.roles = this.isCoach ? ["robotics:coach"] : ["team:member"];

      if (this.community === "fll-open-brazil") {
        delete this.model.cpf;
      }

      method(this.model, this.modelId, this.teamId).then(
        (model) => {
          this.loading = false;

          // Emit created event
          this.$emit("answer", model.data);

          // Reset state (set model if was creating)
          if (this.isNew) {
            this.model = this.defaults;
          }

          // Show sucess message
          this.$notify.success({
            title: "Usuário salvo",
            message: "Seu usuário foi salvo com sucesso",
          });
        },
        (err) => {
          const status = ParseHTTPError(err);
          let error = status.error;

          if (!status.type) {
            error =
              "Houve um erro na comunicação com o servidor, tente novamente";
          }

          this.$notify.error({
            title: "Erro",
            message: error,
          });
          this.loading = false;
        },
      );
    },
  },
};
</script>

<style scoped src="./Editor.css"></style>



// WEBPACK FOOTER //
// src/components/Users/Editor/index.vue